import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/OfficeDepartment";

export const getOfficeDepartment = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res;
  });
};

export const addOfficeDepartment = async (newDept) => {
  return axios.post(`${api_base_url}`, {
    ...newDept,
  });
};

export const deleteOfficeDepartment = async (ids) => {
  await axios.delete(`${api_base_url}`, {
    data: ids,
  });
};

export const updateOfficeDepartment = async (updateDepartment) => {
  const formData = new FormData();
  updateDepartment.officeDepartmentId &&
    formData.append("officeDepartmentId", updateDepartment.officeDepartmentId);
  updateDepartment.officeDepartmentName &&
    formData.append(
      "officeDepartmentName",
      updateDepartment.officeDepartmentName
    );
  updateDepartment.createdBy &&
    formData.append("createdBy", updateDepartment.createdBy);
  updateDepartment.createdDate &&
    formData.append("createdDate", updateDepartment.createdDate);
  updateDepartment.isActive !== undefined &&
    formData.append("isActive", updateDepartment.isActive);
  return axios.put(`${api_base_url}`, formData);
};
